<div class="business-list-view col-md-12 padding-right-0 padding-left-0">
  <!-- Wireframe header (.section-hd + .panel-search). Old header in #legacyHeader. -->
  <div class="gs-biz-list-hd" *ngIf="useWireframeHeader; else legacyHeader">
    <div class="gs-biz-list-row">
      <div class="gs-biz-list-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        Page Admins
        <span class="gs-biz-list-count" *ngIf="responseReceived">({{adminListing?.length || 0}})</span>
      </div>
      <div class="gs-biz-list-actions">
        <div dropdown class="btn-group"
          *ngIf="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true'"
          #filterDropdown="bs-dropdown"
          (onShown)="bindDropdownAutoClose(filterDropdown)"
          (onHidden)="unbindDropdownAutoClose()">
          <button type="button" class="gs-biz-list-btn" dropdownToggle aria-controls="admin-filter-menu">
            {{filterName}}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
          </button>
          <ul id="admin-filter-menu" *dropdownMenu class="dropdown-menu dropdown-menu-right no-padding" role="menu">
            <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'All'" (click)="adminFilter('ALL'); $event.stopPropagation();">All</a></li>
            <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Admin'" (click)="adminFilter('ADMIN'); $event.stopPropagation();">Admin</a></li>
            <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Superadmin'" (click)="adminFilter('SUPERADMIN'); $event.stopPropagation();">SuperAdmin</a></li>
          </ul>
        </div>
        <button type="button" *ngIf="businessData?.isSuperAdmin === 'true'" class="gs-biz-list-btn gs-biz-list-btn--primary"
          (click)="openModal(adminTemplate)">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>Add Admin
        </button>
      </div>
    </div>
    <div class="gs-biz-list-search">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input type="text" placeholder="Search admins…" aria-label="Search admins" [(ngModel)]="searchKey"
        [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchAdmin($event)">
      <button *ngIf="searchKey" type="button" class="gs-biz-list-clear" aria-label="Clear search"
        (click)="searchKey = ''; onSearchAdmin('')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
  </div>

  <ng-template #legacyHeader>
  <div class="hpanel gs-card">
    <div class="Bnav panel-body">
      <div class="Bnav-item-11">
        <h6 class="fw-bold" data-toggle="tooltip" data-placement="top" title="{{businessData?.businessName}}">
          {{businessData?.businessName | truncate : 22 }}
        </h6>
        <div>
          <p *ngIf="responseReceived">{{adminListing?.length || 0}}
            {{(adminListing?.length || 0) <= 1 ? 'Admin' : 'Admins'}}</p>
        </div>
      </div>
      <div class="Bnav-item-22 pos-rel-10">
        <!-- <input type="text" class="form-control" placeholder="Search Admin"  [(ngModel)]="name"
              [ngModelOptions]="{standalone: true}" (keyup)="keyupdata($event)" (keyup.enter)="onsearch(name)" aria-label="Amount (to the nearest dollar)">
              <span class="input-group-addon"  (click)="onsearch(name)" id="my_btn" ><ng-icon name="tablerSearch"></ng-icon></span>           -->

        <input type="text" class="form-control pd-lt-10 search-field-pad" placeholder="Search Admin" [(ngModel)]="searchKey"
          [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchAdmin($event)"
          aria-label="Amount (to the nearest dollar)">
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>

      </div>
      <div dropdown class="Bnav-item-333 btn-group" container="body"
        *ngIf="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true' "
        #filterDropdown="bs-dropdown"
        (onShown)="bindDropdownAutoClose(filterDropdown)"
        (onHidden)="unbindDropdownAutoClose()">
        <button id="button-container" class="btn btn-primary dropdown-toggle" dropdownToggle
          aria-controls="dropdown-container" style="border-radius: 8px !important; height: 31px !important;">
          <div class="filter-common" style="gap: 5px !important;">
            <span>{{filterName}}</span>
            <ng-icon name="tablerFilter"></ng-icon>
          </div>
        </button>
        <ul id="dropdown-container" *dropdownMenu class="dropdown-menu no-padding" role="menu" aria-labelledby="button-container">
          <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'All'" (click)="adminFilter('ALL'); $event.stopPropagation();">All</a></li>
          <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Admin'" (click)="adminFilter('ADMIN'); $event.stopPropagation();">Admin</a></li>
          <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Superadmin'" (click)="adminFilter('SUPERADMIN'); $event.stopPropagation();">SuperAdmin</a></li>
        </ul>
      </div>

      <div class="Bnav-item-4">
        <!-- <button class="btn primary-btn"  disabled >Advance Search</button> -->
        <button type="submit" *ngIf="businessData?.isSuperAdmin === 'true'" class="btn primary-btn right"
          (click)="openModal(adminTemplate)" style="font-size: 12px;">
          Add Admin<span class="iuiy">
            <!-- <ng-icon name="tablerUserPlus" class="font-15"></ng-icon> -->
          </span>
        </button>
      </div>
      <!-- <div class="Bnav-item-5">
        <button type="submit" *ngIf="superadminflag"
                  class="btn primary-btn right" (click)="openModal(adminTemplate)">
                  <ng-icon name="tablerPlus"></ng-icon> Add Admin
        </button>
      </div> -->
    </div>
  </div>
  </ng-template>
  <!-- ── Wireframe cards (useWireframeCards): same card as Employees/Followers ── -->
  <div class="ba-wf-grid" *ngIf="useWireframeCards">

    <ng-container *ngIf="!responseReceived">
      <div *ngFor="let n of [1, 2, 3, 4, 5, 6]">
        <app-common-skeleton [NameOftheScreen]="'usercardWireframe'"></app-common-skeleton>
      </div>
    </ng-container>

    <!-- Plain members: shared user card (see the condition note in the old block below). -->
    <ng-container
      *ngIf="responseReceived && businessData?.isSuperAdmin !== 'true' && businessData?.isAdmin != 'true'">
      <div *ngFor="let admin of adminListing">
        <app-user-card [button]="'PRIMARY'" [userDataInput]="admin" [variant]="'wireframe'" [showStats]="false"></app-user-card>
      </div>
    </ng-container>

    <!-- Admins: own card for the admin actions; markup/values mirror user-card .uc-wf-*. -->
    <ng-container *ngIf="responseReceived && (businessData?.isSuperAdmin === 'true' || businessData?.isAdmin=='true')">
      <div *ngFor="let admin of adminListing">
        <div class="ba-wf-card">
          <div class="ba-wf-body">
            <div class="ba-wf-av" (click)="userprofile(admin.userId)">
              <img *ngIf="admin.photo" [src]="photoUrl + admin.photo" alt="">
              <div *ngIf="!admin.photo" class="ba-wf-initials"
                [style.background-color]="getColor(admin?.firstName, admin?.lastName)"
                [style.color]="getTextColor(admin?.firstName, admin?.lastName)">{{ getInitials(admin?.firstName, admin?.lastName) }}</div>
            </div>
            <div class="ba-wf-main">
              <div class="ba-wf-name-row">
                <a class="ba-wf-name" [title]="admin.fullName" (click)="userprofile(admin.userId)">{{ admin.fullName }}</a>
                <div class="ba-wf-tools">
                  <img *ngIf="admin.type=='SUPERADMIN'" class="ba-wf-role" title="Owner" src="assets/icon/crown_.PNG" alt="Owner">
                  <img *ngIf="admin.type=='ADMIN'" class="ba-wf-role" title="Admin" src="assets/icon/admin_cogs.PNG" alt="Admin">
                  <span *ngIf="admin.userId == loginUserId" class="ba-wf-you">You</span>
                  <div *ngIf="admin.userId!=userId && businessData?.isSuperAdmin === 'true' && admin.type=='ADMIN'"
                    class="btn-group" dropdown placement="bottom right">
                    <button type="button" dropdownToggle class="ba-wf-kebab" aria-label="More options">
                      <svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="12" cy="19" r="1.8"/></svg>
                    </button>
                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right ba-wf-menu-list" role="menu">
                      <li
                        *ngIf="(planType === 'Free' && (admin?.userType === 'RECRUITER'
                            || admin?.userType === 'BENCH_RECRUITER'
                            || admin?.userType === 'MANAGEMENT_TALENT_ACQUISITION')) ||
                          ((planType === 'Starter' || planType === 'Growth' || planType === 'ScaleX') &&
                            admin?.userType === 'MANAGEMENT_TALENT_ACQUISITION')"
                        role="menuitem">
                        <a class="dropdown-item" (click)="superAdmin(superAdminTemplate, admin.userId)">Make Super Admin</a>
                      </li>
                      <li role="menuitem">
                        <a class="dropdown-item" (click)="revoke(revokeTemplate, admin.userId)">Revoke</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="ba-wf-rows">
                <div class="ba-wf-row" *ngIf="admin.title">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
                  <span [title]="admin.title">{{ admin.title }}</span>
                </div>
                <div class="ba-wf-row" *ngIf="admin.organisation">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
                  <span [title]="admin.organisation">{{ admin.organisation }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="ba-wf-footer">
            <button type="button" class="ba-wf-foot-btn" (click)="userprofile(admin.userId)">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>View profile
            </button>
            <ng-container *ngIf="admin.userId!=userId">
              <div class="ba-wf-divider"></div>
              <button type="button" class="ba-wf-foot-btn" (click)="sendmsg(admin)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>Send Message
              </button>
            </ng-container>
            <ng-container *ngIf="admin.userId==userId && businessData?.isSuperAdmin === 'true' && admin.type!='ADMIN'">
              <div class="ba-wf-divider"></div>
              <button type="button" class="ba-wf-foot-btn" (click)="transferModal(transferTemplate)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>Transfer Rights
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- ── Previous cards (useWireframeCards = false) ── -->
  <div class="" *ngIf="!useWireframeCards">


    <ng-container *ngIf="!responseReceived">
      <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0"
        *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
        <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
      </div>
    </ng-container>

    <!-- Plain-member view. The condition must exclude admins as well as
         superadmins, not just superadmins: an Admin who is not a SuperAdmin has
         isSuperAdmin === 'false' AND isAdmin == 'true', which satisfied BOTH this
         block and the privileged one below, so every admin rendered twice — once
         as an app-user-card and once as the inline admin card. -->
    <ng-container
      *ngIf="responseReceived && businessData?.isSuperAdmin !== 'true' && businessData?.isAdmin != 'true'">
      <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0" style="margin-bottom: 10px;"
        *ngFor="let admin of adminListing">
        <app-user-card [button]="'PRIMARY'" [userDataInput]="admin"></app-user-card>
      </div>
    </ng-container>


    <ng-container *ngIf="responseReceived && (businessData?.isSuperAdmin === 'true' || businessData?.isAdmin=='true')">
      <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 card" *ngFor="let admin of adminListing">
        <div class="hpanel gs-card margin-bottom-5 contact-panel">

          <div class="panel-body bus-admin-card-design border-radius-top-left-right-6 border-radius-bottom-left-right-0"
            (click)="userprofile(admin.userId)">


            <!-- <div class="btn-group pull-right m-t-m-10"> -->
            <!-- <img alt="logo" class="img-circle" src={{admin.photo}}>
              <img alt="logo" class="img-circle" *ngIf="admin.photo==undefined || admin.photo==null || admin.photo==''"
                src="assets/images/gallery/1.jpg"> -->

            <div class="flex-space-between">
              <img *ngIf="admin.photo != undefined && admin.photo != null" alt="logo" class="img-circle"
                src={{photoUrl+admin.photo}}>

              <div *ngIf="admin.photo == undefined || admin.photo == null" class="circles " style="cursor: pointer;"
                [style.background-color]="getColor(admin?.firstName, admin?.lastName)">
                <div class="circle-text" [style.color]="getTextColor(admin?.firstName, admin?.lastName)">{{
                  getInitials(admin?.firstName, admin?.lastName) }}
                </div>
              </div>
              <div class="btn-group  m-t-0.6rm right" dropdown>
                <div *ngIf="admin.userId == loginUserId && businessData?.isSuperAdmin === 'false'">
                  <span class="label label-info font-normal" style="font-size: 11px;">You</span>
                </div>
                <button type="button" class="btn primary-btn  btn-xs crv commom-font-12"
                  *ngIf="admin.userId==userId && businessData?.isSuperAdmin === 'true' && admin.type!='ADMIN'"
                  (click)="transferModal(transferTemplate);$event.stopPropagation();">Transfer Rights</button>

                <button type="button" class="btn btn-primary b-5 ieoslf btn-xs" *ngIf="admin.userId!=userId"
                  (click)="sendmsg(admin);$event.stopPropagation();">Send Message
                  <!-- Same trailing mail icon the employees card puts on its
                       Send Message button (user-card.component.html:33). -->
                  <ng-icon name="tablerMail" class="jwsk gs-icon-action" aria-hidden="true"
                    style="vertical-align: -0.25em !important;"></ng-icon>
                </button>

                <div class="btn-group three_icon_cmon1 hovers" id="the-dropdown" dropdown
                  (click)="$event.stopPropagation();">
                  <a id="button-animated" dropdownToggle (click)="$event.stopPropagation();" data-toggle="dropdown"
                    *ngIf="admin.userId!=userId && businessData?.isSuperAdmin === 'true' && admin.type=='ADMIN'"
                    class="m-r-5">
                    <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dote">
                  </a>
                  <ul class="dropdown-menu r-0-l-auto fnt-12" *dropdownMenu role="menu">
                    <li
                      *ngIf="businessData?.isSuperAdmin === 'true' && admin.type === 'ADMIN' &&
                                   ((planType === 'Free' &&  (admin?.userType === 'RECRUITER'
                          || admin?.userType === 'BENCH_RECRUITER'
                          || admin?.userType === 'MANAGEMENT_TALENT_ACQUISITION'))||
                          ((planType === 'Starter' || planType === 'Growth' || planType === 'ScaleX') &&
                             admin?.userType === 'MANAGEMENT_TALENT_ACQUISITION'))"
                      role="menuitem">

                      <a class="dropdown-item commom-font-12"
                        (click)="superAdmin(superAdminTemplate, admin.userId); $event.stopPropagation();">
                        Make Super Admin
                      </a>
                    </li>
                    <li *ngIf="businessData?.isSuperAdmin === 'true' && admin.type=='ADMIN'" role="menuitem"><a
                        class="dropdown-item commom-font-12"
                        (click)="revoke(revokeTemplate,admin.userId);$event.stopPropagation();">Revoke</a> </li>
                  </ul>
                </div>
              </div>

            </div>


            <div class="row">
              <div class="col-sm-8">
                <h6 class="ellipse fw-bold" (click)="userprofile(admin.userId)" data-toggle="tooltip"
                  data-placement="top" title="{{admin.fullName}}">
                  {{admin.fullName }}
                </h6>
              </div>

              <div>
                <span *ngIf="admin.type=='SUPERADMIN'"><img class="ba-crown" title="Owner" src="assets/icon/crown_.PNG"
                    alt=""></span>
                <span *ngIf="admin.type=='ADMIN'"><img class="admin-cogs" title="Admin" src="assets/icon/admin_cogs.PNG"
                    alt=""></span>
              </div>

            </div>

            <div class="item">
              <p class="ellipse" data-toggle="tooltip" data-placement="top" title="{{admin.title}}">
                {{admin.title }}
              </p>
              <p class="ellipse" data-toggle="tooltip" data-placement="top" title="{{admin.organisation}}">
                {{admin.organisation }}
              </p>
            </div>
          </div>



          <!-- <div class="admin-footer">

            <div class="w-100" *ngIf="(admin?.userType === 'MANAGEMENT_TALENT_ACQUISITION' || admin?.userType === 'FREELANCE_RECRUITER')">
              <div class="col-md-3 border-right">
                <div class="contact-stat"><span>Connections: </span>
                  <strong *ngIf="admin.connectionCnt === null || admin.connectionCnt === undefined">0</strong>
                  <strong>{{ admin.connectionCnt != null && admin.connectionCnt != undefined ? admin.connectionCnt : '0'
                    }}</strong>
                </div>
              </div>

              <div class="col-md-3">
                <div class="contact-stat"><span>Jobs : </span>
                  <strong>{{ admin.jobsCount != null && admin.jobsCount != undefined ? admin.jobsCount : '0' }}</strong>
                </div>
              </div>

              <div class="col-md-3">
                <div class="contact-stat"><span>Candidates : </span>
                  <strong>{{ admin.candidatesCount != null && admin.candidatesCount != undefined ? admin.candidatesCount : '0'
                    }}</strong>
                </div>
              </div>
            </div>


            <div class="w-100"  *ngIf="(admin?.userType === 'RECRUITER' || admin?.userType === 'BENCH_RECRUITER' || admin?.userType === 'JOB_SEEKER')">


              <div class="col-md-6 border-right">
                <div class="contact-stat">
                  <span>Connections: </span>
                  <strong>{{ admin.connectionCnt != null && admin.connectionCnt != undefined ? admin.connectionCnt : '0'
                    }}</strong>
                </div>
              </div>

              <div class="col-md-6">

                <div *ngIf="admin?.userType === 'RECRUITER'" class="contact-stat">
                  <span> Jobs : </span>
                  <strong>{{ admin.jobsCount != null && admin.jobsCount != undefined ? admin.jobsCount : '0' }}</strong>
                </div>

                <div *ngIf="admin?.userType === 'BENCH_RECRUITER' || admin?.userType === 'JOB_SEEKER'" class="contact-stat">
                  <span> Candidates : </span>
                  <strong>{{ admin.candidatesCount != null && admin.candidatesCount != undefined ? admin.candidatesCount : '0' }}
                  </strong>
                </div>

              </div>

            </div>

          </div> -->

          <div class="border-radius-bottom-left-right-6 admin-footer">

            <!-- Connections count -->
            <div class="contact-stat flx-111">
              <span>Connections</span>
              <strong *ngIf="admin.connectionCnt != null && admin.connectionCnt != undefined">{{ admin.connectionCnt
                }}</strong>
              <strong *ngIf="admin.connectionCnt == null || admin.connectionCnt == undefined">0</strong>
            </div>
            <!-- Jobs count -->
            <div class="contact-stat flx-111"
              *ngIf="(admin?.userType === 'MANAGEMENT_TALENT_ACQUISITION' || admin?.userType === 'FREELANCE_RECRUITER' || admin?.userType === 'RECRUITER')">
              <span>Jobs</span>
              <strong *ngIf="admin.jobsCount != null && admin.jobsCount != undefined">{{ admin.jobsCount }}</strong>
              <strong *ngIf="admin.jobsCount == null || admin.jobsCount == undefined">0</strong>
            </div>
            <!-- Candidates count -->
            <div class="contact-stat flx-111"
              *ngIf="(admin?.userType === 'MANAGEMENT_TALENT_ACQUISITION' || admin?.userType === 'FREELANCE_RECRUITER' || admin?.userType === 'BENCH_RECRUITER' || admin?.userType === 'JOB_SEEKER')">
              <span>Candidates</span>
              <strong *ngIf="admin.candidatesCount != null && admin.candidatesCount != undefined">{{
                admin.candidatesCount }}</strong>
              <strong *ngIf="admin.candidatesCount == null || admin.candidatesCount == undefined">0</strong>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Empty state (shown for either layout once the admin list comes back empty,
       e.g. a search with no matches). Mirrors Employees/Followers. -->
  <div class="col-md-12 pad" *ngIf="responseReceived && adminListing?.length === 0">
    <app-nodata-found [title]="noDatafound" [buttonShow]="false"></app-nodata-found>
  </div>
</div>
<ng-template #adminTemplate>
  <div class="common-header-flex">
    <div>Add Admin</div>
    <button>
      <span class="common-close" (click)="close()">&times;</span>
    </button>
  </div>

  <!-- ===================================================================== -->
  <!-- LAYOUT: adopted from the Job Center "Transfer Jobs" dialog            -->
  <!-- (customer-business-joblist.component.html:131) so both dialogs share  -->
  <!-- one structure: .common-header-flex / .modal-body.SuperAdminModelDesign -->
  <!-- > .container / .modal-footer.                                         -->
  <!--                                                                       -->
  <!-- The previous layout is kept below, commented out, for reference. It   -->
  <!-- used .modal-body > .container-fluid > .row (+ .col-sm-12) for the body -->
  <!-- and .custom-panel-footer > .panel-footer > .footer-flex for the       -->
  <!-- actions. That mixed three different horizontal insets (15px container -->
  <!-- padding, -15px row margins, 15px column padding) which is why the     -->
  <!-- instruction text, the search field and the buttons never lined up.    -->
  <!-- ===================================================================== -->
  <div class="modal-body SuperAdminModelDesign">
    <div class="container">
      <div class="col-sm-12">
        <p>Only Employees of this Business who are connected to you can be added as Admins</p>
      </div>
      <!-- ng-select, not ng-autocomplete, and for behaviour rather than looks:
           ng-autocomplete's select() assigns the chosen name straight into the
           input (`this.query = item[searchKeyword]`,
           autocomplete.component.mjs:206). The selection IS the text, so it can
           render no chip, and reopening the list filters it by that text — which
           is why only the already-selected person came back. ng-select keeps the
           value separate from the search term, giving the chip + ✕ and a full
           list on reopen, exactly like the Job Center Transfer picker.

           `gs-clear-plain` is the shared app-wide modifier the other search
           selects use, so no dialog-specific CSS is needed here. -->
      <div class="col-sm-12">
        <ng-select class="gs-clear-plain" [items]="employeeList" [multiple]="false" [closeOnSelect]="true"
          [hideSelected]="false" bindLabel="userName" bindValue="userId"
          [(ngModel)]="addAdminId" [ngModelOptions]="{standalone: true}"
          placeholder="Search in employee name" notFoundText="No employee found"
          appendTo=".gs-add-admin-modal">

          <ng-template ng-option-tmp let-item="item">
            <div class="item">
              <img *ngIf="item.photo != undefined && item.photo != null" alt="logo" class="img-circle"
                src={{photoUrl+item.photo}}>

              <div *ngIf="item.photo == undefined || item.photo == null" class="circles img-circle"
                style="cursor: pointer;" [style.background-color]="getColor(item?.firstName, item?.lastName)">
                <div class="admin-circle-text" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{
                  getInitials(item?.firstName, item?.lastName) }}
                </div>
              </div>

              <a routerLinkActive="router-link-active" [innerHTML]="item.userName"></a> &nbsp;
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="decline()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="addAdmin()">Add Admin</button>
  </div>

  <!-- ===== PREVIOUS LAYOUT (replaced by the Job Center structure above) =====
  <div class="modal-body">
    <div class="container-fluid">
      <div>
        <div class="row">
          <p>Only Employees of this Business who are connected to you can be added as Admins</p>
        </div>
        <div [formGroup]="serachForm">
          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                <ng-autocomplete ...></ng-autocomplete>
              </div>
              <ng-template #itemTemplate let-item>...</ng-template>
              <ng-template #notFoundTemplate>...</ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="decline()">Cancel</button>
        <button class="btn primary-btn" (click)="addAdmin()">Add Admin</button>
      </div>
    </div>
  </div>
  ======================================================================== -->

</ng-template>

<ng-template #transferTemplate>
  <div class="modal-content">
    <div class="common-header-flex">
      <div>Transfer Super Admin Rights</div>
      <button>
        <span class="common-close" (click)="decline()">&times;</span>
      </button>
    </div>


    <div class="modal-body">
      <div class="container-fluid">
        <div class="row">
          <p>You will no longer be the Super Admin of this Business Page and will not be able to manage other Admins.
          </p>
          <p>
            Super Admin rights can be transferred only to other employees
            {{ (planType === 'Starter' || planType === 'Growth' || planType === 'ScaleX') ? 'connected with MTA Role' : 'connected' }}
          </p>
        </div>
        <div [formGroup]="serachForm">
          <div class="form-group">
            <div class="row">
              <ng-autocomplete [data]="autoCompleteAdminList" [searchKeyword]="keyword"
                (selected)='selectEvent1($event)' (inputChanged)='onChangeSearch($event)' formControlName="serachData"
                (inputFocused)='onFocused1($event)' [itemTemplate]="itemTemplate" placeHolder="Search In Name"
                [notFoundTemplate]="notFoundTemplate">
              </ng-autocomplete>
              <ng-template #itemTemplate let-item>
                <div class="item">
                  <img *ngIf="item.photo != undefined && item.photo != null" alt="logo" class="img-circle"
                    src={{photoUrl+item.photo}}>

                  <div *ngIf="item.photo == undefined || item.photo == null" class="circles" style="cursor: pointer;"
                    [style.background-color]="getColor(item?.firstName, item?.lastName)">
                    <div class="circle-text" [style.color]="getTextColor(item?.firstName, item?.lastName)">{{
                      getInitials(item?.firstName, item?.lastName) }}
                    </div>
                  </div>
                  <a routerLinkActive="router-link-active" [innerHTML]="item.userName"></a> &nbsp;
                </div>
              </ng-template>
              <ng-template #notFoundTemplate let-notFound>
                <!-- <div [innerHTML]="notFound"></div> -->
                   <div>No employee found</div>
              </ng-template>

            </div>
          </div>
        </div>
        <div class="row float-r">
          <button class="btn btn-default" style="margin-right: 5px;" (click)="decline()">Cancel</button>
          <button class="btn primary-btn" (click)="makeSuperadmin()">Make Super Admin</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #revokeTemplate>

  <div class="common-header-flex">
    <div>Revoke </div>
    <button><span class="common-close" (click)="modalRef.hide()" aria-hidden="true">&times;</span></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <div class="row">
        <p>Once you revoke Admin rights, user will no longer be able to manage this page</p>
      </div>
      <div class="row" style="padding-left: 78%;">
        <button class="btn btn-default" style="border-radius: 3px;  margin-left: -26px;" (click)="decline()">Cancel</button>
        <button class="btn primary-btn" style="margin-left: 6px;" (click)="removeAdmin()">Revoke</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #superAdminTemplate>
  <div class="modal-content">

    <div class="common-header-flex">
      <div>Make Super Admin</div>
      <button><span class="common-close" (click)="modalRef.hide()" aria-hidden="true">&times;</span></button>
    </div>


    <div class="modal-body">
      <div class="container-fluid">
        <div class="row">
          <p>Only Employees of this Business who are connected to you can be added</p>
        </div>
        <div class="custom-form">
          <div [formGroup]="serachForm">
            <div class="form-group">
              <div class="row" style="padding-left: 40px;">
                <div class="ng-autocomplete width-500"
                  style="color: black !important; background-color: black !important;">
                </div>
              </div>
            </div>
            <div class="text-right">
              <button class="btn btn-default " (click)="decline()">
                Cancel
              </button>
              <button style="margin-left:2%;" class="btn primary-btn " type="button" (click)="makeadmin()">
                Make Super Admin
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
